import { useEffect } from 'react';

export interface ToastProps {
  message: string | null;
  onDismiss: () => void;
  durationMs?: number;
}

/**
 * Transient feedback that never takes focus.
 *
 * Deliberately not focusable and not a dialog: a message about a refused action
 * must not steal the D-pad from the row the player is working through.
 */
export function Toast({ message, onDismiss, durationMs = 3000 }: ToastProps) {
  useEffect(() => {
    if (message === null) return;
    const timer = setTimeout(onDismiss, durationMs);
    return () => clearTimeout(timer);
  }, [message, durationMs, onDismiss]);

  if (message === null) return null;

  return (
    <div className="toast" role="status" aria-live="polite" data-testid="toast">
      {message}
    </div>
  );
}
